module.exports = __webpack_public_path__ + "static/footer-map-2fa386293ed1cc3bce54f4ec5e8b7943.png";